<div class="flex-1 d-flex overflow-auto">
    <kui-table #table
        class="h-100"
        [selectionMode]="'single'"
        selectionColumn="id"
        [nowrap]="true"
        [rows]="rows"
        [cols]="cols"
        [resize]="false"
        [selection]="true"
        (onRowSelect)="onRowSelected($event)">
    </kui-table>
</div>
<div class="border-top d-flex align-items-center"
    style="min-height: 35px"
    *ngIf="!errorMessage && rows">
    <div class="flex-1">
        <kui-paginate [page]="page"
            [total]="total"
            [perPage]="limit"
            [collapse]="true"
            (pageChanged)="onPageChanged($event)"></kui-paginate>
    </div>
    <div *ngIf="!!handler?.visibleActions?.length" class="pr-3 overflow-hidden">
        <kui-icon *ngIf="handler.visibleActions.includes('add')"
            kui-action
            name="plus"
            size="sm"
            class="ml-2"
            (click)="addClicked()"></kui-icon>
        <kui-icon *ngIf="handler.visibleActions.includes('delete')"
            kui-action
            name="trash-alt"
            size="sm"
            class="ml-2"
            [class.disabled]="!selectedRow"
            (click)="deleteClicked()"></kui-icon>
    </div>
</div>